export default __webpack_public_path__ + "static/media/accept.3d6b413c.svg";